import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  photo: {
    width: '300px',
    height: '160px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '3px',
    backgroundColor: '#E2F5F8',
    marginBottom: '15px'
  },
  title: {
    marginBottom: '10px'
  },
  description: {
    marginBottom: '20px'
  },
  location: {
    display: 'flex',
    alignItems: 'end',
    marginBottom: '20px'
  },
  locationIcon: {
    fontSize: '20px',
    marginRight: '10px'
  },
  locationText: {
    marginTop: '1px'
  },
  infoDatesTitle: {
    marginBottom: '10px'
  },
  datesItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px'
  },
  infoValue: {
    fontWeight: 'normal'
  },
  datesWrapper: {
    marginBottom: '20px'
  }
});

export default useStyles;
